import { render, staticRenderFns } from "./SimpleAnalytics.vue?vue&type=template&id=671730b7"
import script from "./SimpleAnalytics.vue?vue&type=script&lang=js"
export * from "./SimpleAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports